<app-modal [title]="weekExists() ? 'Edit Requirement' : 'Add Requirement'" #modalComponent>
  <form (ngSubmit)="onSubmit()" #f="ngForm" class="p-3" autocomplete="off">

    <div class="mb-3">
      <label for="minOpeningEmployees">Min opening employees</label>
      <input class="form-control"
             type="number"
             id="minOpeningEmployees"
             name="minOpeningEmployees"
             [ngModel]="minimumOpeningEmployees()"
             (ngModelChange)="minimumOpeningEmployees.set($event)"
             required
             min="0"
             pattern="\d+"
             #minOpeningEmployees="ngModel">
      @if (minOpeningEmployees.errors && minOpeningEmployees.touched) {
        <div class="form-error-message">
          @if (minOpeningEmployees.errors.required) {
            <p>Min opening employees is required</p>
          } @if (minOpeningEmployees.errors.pattern) {
          <p>Min opening employees must be non-negative</p>
        }
        </div>
      }
    </div>

    <div class="mb-3">
      <label for="minRegularEmployees">Min regular employees</label>
      <input class="form-control"
             type="number"
             id="minRegularEmployees"
             name="minRegularEmployees"
             [ngModel]="minimumRegularEmployees()"
             (ngModelChange)="minimumRegularEmployees.set($event)"
             required
             min="0"
             pattern="\d+"
             #minRegularEmployees="ngModel">
      @if (minRegularEmployees.errors && minRegularEmployees.touched) {
        <div class="form-error-message">
          @if (minRegularEmployees.errors.required) {
            <p>Min employees is required</p>
          } @if (minRegularEmployees.errors.pattern) {
          <p>Min employees must be non-negative</p>
        }
        </div>
      }
    </div>

    <div class="mb-3">
      <label for="minClosingEmployees">Min closing employees</label>
      <input class="form-control"
             type="number"
             id="minClosingEmployees"
             name="minClosingEmployees"
             [ngModel]="minimumClosingEmployees()"
             (ngModelChange)="minimumClosingEmployees.set($event)"
             required
             min="0"
             pattern="\d+"
             #minClosingEmployees="ngModel">
      @if (minClosingEmployees.errors && minClosingEmployees.touched) {
        <div class="form-error-message">
          @if (minClosingEmployees.errors.required) {
            <p>Min closing employees is required</p>
          } @if (minClosingEmployees.errors.pattern) {
          <p>Min closing employees must be non-negative</p>
        }
        </div>
      }
    </div>

    <app-input-date
            [isDisabled]="weekExists()"
            [placeholder]="'Start date'"
            [name]="'startDate'"
            [(inputDate)]="startDate"
            [editDate]="editDate"
            [onlyMondays]="true">
    </app-input-date>

    <div class="mt-4 text-end">
      <button class="btn btn-primary-outline btn-form me-3 close-button" type="button"
              (click)="modalComponent.activeModal.close()">Close
      </button>
      <button
              class="btn btn-primary btn-form save-button"
              type="submit"
              [disabled]="!f.valid || !startDate() || loading()">Save
      </button>
    </div>
  </form>
</app-modal>